import { gql } from '__generated__';

export default gql(`
  query GetFields($project_id: ID!, $event_id: ID!) {
    project(id: $project_id) {
      id
      event(id: $event_id) {
        ...GetFieldsEvent
      }
      mail_permissions {
        id
        title
        events {
          id
        }
        interest_list_event {
          id
        }
      }
    }
  }
`);

export const GetFieldsEventFragment = gql(`
  fragment GetFieldsEvent on Event {
    id
    title
    locale
    participant_attributes
    optional_participant_attributes
    tickets {
      id
      title
      participant_attributes
    }
    participant_fields {
      ...GetFieldsParticipantField
    }
    mail_permissions {
      id
      events {
        id
      }
    }
  }
`);
export const GetFieldsParticipantFieldFragment = gql(`
  fragment GetFieldsParticipantField on ParticipantField {
    id
    title
    description
    scope
    type
    choices {
      id
      title
      enabled
      deletable
      translations {
        ...TranslationFields
      }
    }
    required
    unique
    tickets {
      id
      title
    }
    products {
      id
      title
    }
    promotions {
      id
      title
    }
    config
    validation_url
    validation_success_response
    position
    enabled
    field_entry_count
    deletable
    translations {
      ...TranslationFields
    }
  }
`);
